import $ from '@ali/tarzan-zepto';
import querystring from 'querystring';
import Model from './model';
import App from '../../app/index.js';
import lang from './lang.js';
import util from '../../lib/util';
import './base.scss';


window.alicare_env_ispc = util.isPC();

// 机器人聊天多传access_token,auth_vendor
class Mebot {

  constructor() {
    const env = this.__getQueryString('env');
    this.model = new Model({
      env,
    });
  }

  init(cfg = {}) {
    let ncfg = null;
    ncfg = Object.assign({}, cfg, { model: this.model, lang });
    if (ncfg.param.token) {
      this.model.lazadaLogin({
        _user_access_token: ncfg.param.token,
        appId: ncfg.param.appId,
      }).then((res) => {
        this.model.xcookie = res.xCookie;
        ncfg.param.showLiveAgent = ncfg.param.showLiveAgent;
        ncfg.param.greetingType = ncfg.param.greetingType || 'card';
        this.__lazada(ncfg);
      }, () => {
        this.showError(cfg);
      });
    } else {
      this.model.getToken({
        appId: cfg.param.appId,
      }).then((d) => {
        ncfg.param.token = d;
        this.model.lazadaLogin({
          _user_access_token: d,
          appId: ncfg.param.appId,
        }).then((res) => {
          this.model.xcookie = res.xCookie;
          ncfg.param.showLiveAgent = ncfg.param.showLiveAgent || true;
          ncfg.param.greetingType = ncfg.param.greetingType || 'card';
          this.__lazada(ncfg);
        }, () => {
          this.showError(cfg);
        });
      });
    }
  }

  __lazada(ncfg) {
    this.model.getConfig({
      appId: ncfg.param.appId,
    }).then((res) => {
      this.language = lang(res.language);
      ncfg.config = res;
      ncfg.lang = this.language;
      const app = new App(ncfg);
      this.cfg = ncfg;
      this.app = app;
      this.__init(ncfg);
    });
  }

  __init(cfg) {
    const app = this.app;
    app.start();
    // if (cfg.param.position && cfg.param.size) {
    //   const position = cfg.param.position;
    //   const size = cfg.param.size;
    //   if (position.right && position.bottom) {
    //     this.setPosition(position.left, position.top);
    //   }
    //   if (size.width && size.height) {
    //     this.setSize(size.width, size.height);
    //   }
    // }
    app.on('ready', (e) => {
      cfg.onReady(e, (d) => { this.ready(d); });
    });
    // 跳登陆
    app.on('login', (e) => {
      cfg.onLogin(e, (p) => { this.login(p); });
    });
    // 跳人工
    app.on('liveAgent', (e) => {
      cfg.onLiveAgent(e, (d) => { this.live(d); });
    });
    // 取消订单
    app.on('cancelResult', (e) => {
      cfg.onCancel(e, (d) => { this.cancel(d); });
    });
    // 退款
    app.on('bankTransfer', (e) => {
      cfg.onRefund(e, (d) => { this.cancel(d); });
    });
    // token 超时
    app.on('sessionExpired', () => {
      this.__sessionExpired();
    });
  }

  hide() {
    this.app.app.view.$frame.hide();
  }

  show() {
    this.app.app.view.$frame.show();
    this.app.app.view.resize();
    this.app.pvLog();
    window.alicare_firstmessage.resize();
  }

  destroy() {
    $(this.cfg.container).empty();
    this.app = null;
  }

  ready() {
    console.log('Alime is Ready');
  }

  scrollToBottom() {
    this.app.app.view.scrollToBottom();
  }

  // 重新login
  login(e) {
    if (!e.error || (e.error && e.error.code === 0)) {
      this.model.lazadaLogin({
        _user_access_token: e.token,
        appId: this.cfg.param.appId,
      }).then((res) => {
        this.model.xcookie = res.xCookie;
        this.app.robotMock(
          this.language['LOGIN:SUCCESS']
        );
        if (e.action) {
          this.app.feedback(e);
        }
      }, () => {
        this.app.robotMock(
          this.language['ROBOT:EXCEPTION']
        );
      });
    } else {
      this.app.robotMock(e.error.msg);
    }
  }

  live(e) {
    if (!e.error || (e.error && e.error.code === 0)) {
      this.app.feedback(e);
    } else {
      this.app.robotMock(e.error.msg);
    }
  }

  cancel(e) {
    if (!e.error || (e.error && e.error.code === 0)) {
      this.app.feedback(e);
    } else {
      this.app.robotMock(e.error.msg);
    }
  }

  // 发送消息
  sendMsg(text) {
    this.app.robotMock(text);
  }

  // 错误页面
  showError(cfg) {
    const $tpl = $(`
        <div class="ali-alime-errorpage">
            <div class="error">
                <img src="//gw.alicdn.com/tps/TB1IKcGOpXXXXXvXVXXXXXXXXXX-281-311.png">
                <p>${this.language('PAGE:404')}</p>
                <a href="javascript:;" class="reload">Reload</a>
            </div>
        </div>
    `);
    $(cfg.container || 'body').append($tpl);
    $tpl.find('.reload').on('tap', () => {
      location.reload();
    });
  }

  // 获取参数
  __getQueryString(name) {
    const p = querystring.parse(location.search.replace(/^\?/, ''));
    return p[name];
  }

  // session_expired
  __sessionExpired() {
    this.model.getToken({
      appId: this.cfg.param.appId,
    }).then((d) => {
      this.cfg.param.token = d;
      this.model.lazadaLogin({
        _user_access_token: d,
        appId: this.cfg.param.appId,
      }).then((res) => {
        this.model.xcookie = res.xCookie;
        this.app.robotMock();
      }, () => {
        this.showError(this.cfg);
      });
    });
  }

  setPosition(left, top) {
    this.app.app.view.$frame.css({ left, top });
  }

  setSize(width, height) {
    this.app.app.view.$frame.css({ width, height });
  }

}

const Alime = new Mebot();

export default Alime;



// WEBPACK FOOTER //
// ./src/bu/pc/main.js